<template>
  <div class="contentBox">
    <div>
      <span v-if="pageType == 'download'">{{ $t("forceBind.install") }}</span>
      <span v-if="pageType == 'bind'">{{ $t("forceBind.bind") }}</span>
    </div>
    <span>{{ $t("forceBind.bindPrompt",{username:username}) }}</span>
    <el-divider></el-divider>
    <div v-if="pageType == 'download'" class="serviceBox">
      <div>
        <span>{{ $t("forceBind.downloadPrompt") }}</span>
      </div>
      <div class="mfaDownloadQrCodeBox">
        <div>
          <img
            src="../assets/MFA/authenticator_android.png"
            alt=""
            height="150"
            width="150"
          />
          <span>{{ $t("forceBind.mfaAndroidQrCode") }}</span>
        </div>
        <div>
          <img
            src="../assets/MFA/authenticator_iphone.png"
            alt=""
            height="150"
            width="150"
          />
          <span>{{ $t("forceBind.mfaIosQrCode") }}</span>
        </div>
      </div>
      <div>
        <span>{{ $t("forceBind.nextStepPrompt") }}</span>
      </div>
      <div>
        <el-button type="primary" id="nextStep" @click="nextStep()">{{
          $t("button.nextStep")
        }}</el-button>
      </div>
    </div>
    <div v-if="pageType == 'bind'" class="serviceBox">
      <div>
        <span>{{ $t("forceBind.forceBindPrompt",{username:username}) }}</span>
      </div>
      <div>
        <span>{{ $t("forceBind.captchaPrompt") }}</span>
      </div>
      <div class="qrcode" id="qrcode" ref="qrcode"></div>
      <div class="tableBox">
        <el-form @submit.native.prevent>
          <el-form-item>
            <el-input
              id="googleMFA"
              v-model="code"
              :placeholder="$t('google.mfa')"
              style="width: 70%"
              @keyup.enter.native="googleBind()"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" id="lastStep" @click="beforeStep()">{{
              $t("button.beforeStep")
            }}</el-button>
            <el-button type="primary" id="googleBind" @click="googleBind()" :disabled="submitted">{{
              $t("forceBind.bind")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      googleSecret: "",
      qrcodeContent: "",
      username: "",
      code: "",
      pageType: "download",
      userFirstLogin:false,
      passwordModifyExpires:false,
      submitted:false
    };
  },
  created() {
    this.$route.params.username
      ? (this.username = this.$route.params.username)
      : (this.username = localStorage.getItem("as-username"));
      this.userFirstLogin = this.$route?.params?.userFirstLogin || false;
    this.passwordModifyExpires =
      this.$route?.params?.passwordModifyExpires || false;
    if (this.userFirstLogin || this.passwordModifyExpires) {
      localStorage.setItem(
        "as-pwdFlag",
        JSON.stringify({
          passwordModifyExpires: this.passwordModifyExpires,
          userFirstLogin: this.userFirstLogin,
        })
      );
    }
  },
  methods: {
    getGoogleQrcodeContent() {
      let submitInfo = {
        username: this.username,
      };
      return new Promise((resolve, reject) => {
        this.$httpList
          .getGoogleQrCodeContent(submitInfo)
          .then((res) => {
            if (res.resultCode == 1001) {
              this.googleSecret = res.data.secret;
              this.qrcodeContent = res.data.secretQrCode;

              // 二维码生成
              this.$refs.qrcode.innerHTML = ""; // 清除二维码方法
              new QRCode("qrcode", {
                text: this.qrcodeContent,
                width: 200,
                height: 200,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H,
              });
              resolve(res);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    googleBind() {
      this.submitted=true;
      const pattern = /^\d{6}$/;
      if (this.code && pattern.test(this.code)) {
        let submitInfo = {
          username: this.username,
          secret: this.googleSecret,
          code: this.code,
        };
        return new Promise((resolve, reject) => {
          this.$httpList
            .googleBind(submitInfo)
            .then((res) => {
              setTimeout(()=>{
                this.submitted=false;
              },500)
              if (res.resultCode == 1001) {
                // 绑定成功  重新登录
                this.$notify.success({
                  message: this.$t("google.bindSuccess"),
                });
                if (
                  JSON.parse(this.userFirstLogin) ||
                  JSON.parse(this.passwordModifyExpires)
                ) {
                  this.$router.push({
                    name: "forcePwdChange",
                    params: {
                      userFirstLogin: JSON.parse(this.userFirstLogin),
                      passwordModifyExpires: JSON.parse(
                        this.passwordModifyExpires
                      ),
                    },
                  });
                } else {
                  this.$router.push({
                    name: "Home",
                  });
                }
                resolve(res);
              }
            })
            .catch((err) => {
              this.submitted=false;
              reject(err);
            });
        });
      } else {
        this.submitted=false;
        this.$notify.warning({
          message: this.$t("googleLogin.inputBoxPrompt"),
        });
      }
    },
    nextStep() {
      this.pageType = "bind";
      this.getGoogleQrcodeContent();
    },
    beforeStep() {
      this.pageType = "download";
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = ""; // 清除二维码方法
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contentBox {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex: 1;
  padding: 10%;
  .qrcode {
    height: 200px;
    width: 200px;
    background-color: wheat;
    margin: auto;
  }
  .tableBox {
    margin-top: 20px;
  }
}
.serviceBox {
  div {
    margin-bottom: 30px;
  }
  .mfaDownloadQrCodeBox {
    display: flex;
    justify-content: space-around;
    text-align: center;
    div {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
